import React from 'react'
import StarsQuestion from './StarsQuestion'
import { useTranslation } from 'react-i18next';
import { useSelectLanguage } from '../../hooks/global/Languages';


export default function Score({ value,  question , onChange, sourceId}) {
    const { t, i18n } = useTranslation();
    const lng = i18n.language.toUpperCase();

    const { selectTextByLanguage } = useSelectLanguage()

    const hendleChange = (id, score, index) => {
        onChange?.(question, score);
    }
    return (
        <div key={question.id} className="reviewInvite-questionWrapper no-padding-child-col no-margin-bottom clearfix">
            <div className="row reviewInvite-question clearfix pl-1 px-3">
                <div className="col-sm-5">
                    <h3 className="text-left">{selectTextByLanguage(question.text,lng)}</h3>
                </div>
                <div className="col-sm-7 stars rate starsQuestionReview">
                <StarsQuestion id={question.id} index={sourceId} value={value} onChange={hendleChange} />
                </div>
            </div>
        </div>
    )
}
